import PasswordReset from '../components/PasswordReset';
// import PwdForm from "../components/Forms/PwdForm";

function PassResetPage() {
    return <PasswordReset />;
}
export default PassResetPage;
